var React = require('react');

function Bullseye (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#006aff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m25.3 80.54a41.34 41.34 0 1 0 -19-18.94","key":0}),React.createElement("path",{"d":"m16.22 56a29.87 29.87 0 1 1 14.4 14.46","key":1}),React.createElement("path",{"d":"m30.62 70.42a30 30 0 1 0 -14.4-14.42","key":2}),React.createElement("path",{"d":"m27.05 49.83a17.5 17.5 0 1 1 9.34 9.62","key":3}),React.createElement("path",{"d":"m36.39 59.45a17.62 17.62 0 1 0 -9.34-9.62","key":4}),React.createElement("path",{"d":"m42.41 44.2-32.37 32.19","key":5}),React.createElement("path",{"d":"m9.06 65.71h11.58v12.14","key":6}),React.createElement("path",{"d":"m3.44 71.54h11.58v12.14","key":7}),React.createElement("path",{"d":"m35.05 43.21h8.55v8.2","key":8})]));
}

Bullseye.defaultProps = {"viewBox":"0 0 86.68 86.68"};

module.exports = Bullseye;

Bullseye.default = Bullseye;
